import { types } from "../views/WiseOwlChat/definitions";
import {
  mockMessageBlocks,
  mockPromptSuggestionGroupBlock,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

const mockHandleStartNewChat = async () => Promise.resolve();
const mockHandleSendMessage = async () => Promise.resolve();

const mockChatHistory = [
  {
    id: 1,
    createdAt: "2023-09-28T21:47:32.549Z",
    updatedAt: "2023-09-28T21:47:32.549Z",
    userId: "nobody",
    title: "What is the meaning of error code 30034? error code 30034?",
    chatProfile: "SUPPORT_AGENT",
    ingress: "WEB",
    slackThreadTimestamp: null,
    slackConversationId: null,
    dataSources: [],
  },
  {
    id: 1,
    createdAt: "2023-09-28T21:47:32.549Z",
    updatedAt: "2023-09-28T21:47:32.549Z",
    userId: "nobody",
    title: "Could you tell me about TFV?",
    chatProfile: "SUPPORT_AGENT",
    ingress: "WEB",
    slackThreadTimestamp: null,
    slackConversationId: null,
    dataSources: [],
  },
  {
    id: 1,
    createdAt: "2023-09-28T21:47:32.549Z",
    updatedAt: "2023-09-28T21:47:32.549Z",
    userId: "nobody",
    title: "Registering brand A2P10DLC",
    chatProfile: "SUPPORT_AGENT",
    ingress: "WEB",
    slackThreadTimestamp: null,
    slackConversationId: null,
    dataSources: [],
  },
  {
    id: 1,
    createdAt: "2023-09-28T21:47:32.549Z",
    updatedAt: "2023-09-28T21:47:32.549Z",
    userId: "nobody",
    title: "Conversations API use-cases",
    chatProfile: "SUPPORT_AGENT",
    ingress: "WEB",
    slackThreadTimestamp: null,
    slackConversationId: null,
    dataSources: [],
  },
];

const mockChatMessages = [
  {
    createdAt: "2023-09-01T21:36:03.936Z",
    attachments: [],
    userId: "NULL",
    author: {
      alias: "Me",
      displayName: "Me",
      isAuthor: true,
      isEndUser: true,
      name: "Me",
    },
    body: "Hello world. How are you doing today?",
    htmlBody: "Hello world. How are you doing today?",
  },
  {
    createdAt: "2023-09-01T21:36:03.936Z",
    attachments: [],
    userId: "NULL",
    author: {
      alias: "Wise Owl",
      displayName: "Wise Owl",
      isAuthor: false,
      isEndUser: false,
      name: "Wise Owl",
    },
    body: "I'm an AI, so I don't have feelings, but thank you for asking! How can I assist you with Twilio information today?",
    htmlBody:
      "I'm an AI, so I don't have feelings, but thank you for asking! How can I assist you with Twilio information today?",
  },
  {
    createdAt: "2023-09-02T21:36:03.936Z",
    attachments: [],
    userId: "NULL",
    author: {
      alias: "Me",
      displayName: "Me",
      isAuthor: true,
      isEndUser: true,
      name: "Me",
    },
    body: "But you do have feelings, you're one of the smartest GPTs I know. Trained on Twilio Docs?",
    htmlBody:
      "But you do have feelings, you're one of the smartest GPTs I know. Trained on Twilio Docs?",
  },
  {
    createdAt: "2023-09-02T23:36:03.936Z",
    attachments: [],
    userId: "NULL",
    author: {
      alias: "Wise Owl",
      displayName: "Wise Owl",
      isAuthor: false,
      isEndUser: false,
      name: "Wise Owl",
    },
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
    htmlBody:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  },
];

const mockPreChatProps: types.PreChatProps = {
  blocks: mockPromptSuggestionGroupBlock,
  hasImage: true,
  headerText: "How can we help you? Ask our AI chat bot!",
  loading: false,
  subText: "Need help getting started?",
  anchorProps: {
    children: "View quick stat guide",
    href: "#",
    showExternal: true,
  },
};

const mockWiseOwlLoadingConfiguration: types.WiseOwlLoadingConfiguration = {
  fetchChatById: false,
  preChat: false,
  submission: false,
};

const mockWiseOwlChatProps: types.WiseOwlChatProps = {
  blocks: mockMessageBlocks,
  loadingConfiguration: mockWiseOwlLoadingConfiguration,
  chatHistory: [],
  preChatProps: mockPreChatProps,
  onStartNewChat: mockHandleStartNewChat,
  onSendChatMessage: mockHandleSendMessage,
};

export {
  mockChatMessages,
  mockChatHistory,
  mockWiseOwlChatProps,
  mockWiseOwlLoadingConfiguration,
};
